import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ProfileService } from './auth/services/profile.service';
import { take } from 'rxjs/operators';
import { IconByNameComponent } from './shared/components/icon-by-name.component';
import { ToolbarComponent } from './toolbar.component';
import { ProfileHandlerComponent } from './auth/components/profile-handler.component';
import { LoaderComponent } from './shared/components/loader.component';
import { Router, RouterOutlet, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';

@Component({
  selector: 'con-inside',
  templateUrl: './inside.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IconByNameComponent, ToolbarComponent, ProfileHandlerComponent, LoaderComponent, RouterOutlet],
})
export class InsideComponent implements OnInit {
  public isInitialized = false;
  public isRouteLoading = false;
  constructor(private profileService: ProfileService, private router: Router) {}

  ngOnInit() {
    this.profileService
      .whenReady()
      .pipe(take(1))
      .subscribe((ready) => {
        this.isInitialized = ready;
      });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.isRouteLoading = true;
      } else if (event instanceof NavigationEnd || event instanceof NavigationCancel) {
        this.isRouteLoading = false;
      } else if (event instanceof NavigationError) {
        this.isRouteLoading = false;
        if (/Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|Loading chunk .* failed/i.test(String(event.error?.message ?? event.error))) {
          window.location.href = event.url;
        }
      }
    });
  }
}
